// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n1Vg9","controls":"styles_controls__2Gqy7","charLimit":"styles_charLimit__2yDJi","input":"styles_input__8Jio-","send":"styles_send__1RbxK"};